export const DATASET_PATH = "dataset=2023-01-16_01";
